import { useGetCicoKycStatusQuery } from "apis";
import { useMemo, useRef } from "react";
import { useDispatch } from "react-redux";
import { sidebarTabClick } from "store/slices";
import { when } from "utils";
import SuccessUI from "./SuccessUI";

interface SuccessViewProps {
  reset: () => void;
}

export function CicoKYCSuccess(props: SuccessViewProps) {
  const lastStatus = useRef("none");

  const { data } = useGetCicoKycStatusQuery(null, {
    pollingInterval: when(["expired", "rejected", "approved"].includes(lastStatus.current), undefined, 10000),
  });

  lastStatus.current = data?.status ?? "none";

  const status = useMemo(() => data?.status ?? "Unknown", [data]);

  const dispatch = useDispatch();

  const handleContinue = () => {
    if (status === "KycApproved") {
      dispatch(sidebarTabClick("transfers"));
    }
  };

  return <SuccessUI handleContinue={handleContinue} lastStatus={lastStatus} status={status} />;
}
